import { SEOWebPage } from '../../types'
import { getBaseDomain, makeId } from '../utils'

export interface SEOWebpageInput {
  description: string
  canonicalUrl: string
  name: string
  image: {
    name: string
  }
  hasFaqItems?: boolean
  hasBreadcrumb?: boolean
  hasHowTo?: boolean
  hasItemList?: boolean
  hasArticle?: boolean
}

export const getWebpage = ({
  description,
  canonicalUrl,
  name,
  image,
  hasFaqItems,
  hasBreadcrumb,
  hasHowTo,
  hasItemList,
  hasArticle,
}: SEOWebpageInput): SEOWebPage => {
  const baseDomain = getBaseDomain(canonicalUrl)

  return {
    '@id': makeId(canonicalUrl, 'webpage'),
    '@type': 'WebPage',
    name,
    description,
    url: canonicalUrl,
    image: {
      '@type': 'ImageObject',
      name: image.name,
      url: 'https://static.jusbr.com/images/logo/logo-jusbrasil-1200-675.png',
      height: '675',
      width: '1200',
    },
    inLanguage: 'pt-BR',
    isPartOf: {
      '@id': makeId(baseDomain, 'website'),
    },
    ...(hasBreadcrumb && {
      breadcrumb: {
        '@id': makeId(canonicalUrl, 'breadcrumb'),
      },
    }),
    ...(hasFaqItems || hasHowTo || hasItemList || hasArticle
      ? {
          mainEntity: [
            ...(hasFaqItems ? [{ '@id': makeId(canonicalUrl, 'faq') }] : []),
            ...(hasHowTo ? [{ '@id': makeId(canonicalUrl, 'howto') }] : []),
            ...(hasItemList ? [{ '@id': makeId(canonicalUrl, 'itemlist') }] : []),
            ...(hasArticle ? [{ '@id': makeId(canonicalUrl, 'article') }] : []),
          ].filter(Boolean),
        }
      : {}),
  }
}
